<script>
  import ListItems from './schemaEditor/ListItems.svelte';
  import AlertStructuredDataDifference from './schemaEditor/AlertStructuredDataDifference.svelte';
  import { tipos } from './schemas.js';
  
  let { sds, outputTo, content, onChange } = $props();

  let structuredDatas = $state(sds);
  let loadedContent = $state(content());

  $effect(() => {
    outputTo.value = JSON.stringify(structuredDatas);
    loadedContent = content();
  });

  const append = (tipo_idx) => {
    structuredDatas = [...structuredDatas, tipos[tipo_idx].json];
  };

  onChange(() => {
    loadedContent = content();
  });
</script>

<div class="sd-editor">
  <div>
    <div class="actions">
      <span>Adicionar: </span> <br>
      <span class="btn-group">
        {#each tipos as tipo, i}
          <button onclick={() => append(i)} class="btn btn-sm btn-outline-primary">
            {tipo.name}
          </button>
        {/each}
      </span>
    </div>
    <AlertStructuredDataDifference
      content={loadedContent}
      structuredDatas={structuredDatas}
    />
  </div>
  <hr/>
  <ListItems bind:structuredDatas={structuredDatas}/>
</div>

<style>
  .sd-editor { background: white; border-radius: 5px; padding: 10px }
</style>

